'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["clearLabel", "disabledValues", "max", "maxValidationMessage", "min", "minValidationMessage", "onChange", "today", "todayLabel"];
import I18n from 'I18n';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compare, equals, isDateInRange } from '../../core/SimpleDate';
import SyntheticEvent from '../../core/SyntheticEvent';
import UITooltip from '../../tooltip/UITooltip';
import { SimpleDateType } from '../../types/SimpleDateTypes';
import lazyEval from '../../utils/lazyEval';
import createLazyPropType from '../../utils/propTypes/createLazyPropType';
import CalendarFooterButton from './CalendarFooterButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Outer = styled.div.withConfig({
  displayName: "CalendarFooterButtons__Outer",
  componentId: "yxfm4i-0"
})(["display:flex;justify-content:space-between;margin:16px 0 20px;"]);
const FooterButton = styled(CalendarFooterButton).withConfig({
  displayName: "CalendarFooterButtons__FooterButton",
  componentId: "yxfm4i-1"
})(["flex-basis:50%;"]);
export default function CalendarFooterButtons(props) {
  const {
      clearLabel,
      disabledValues,
      max,
      maxValidationMessage,
      min,
      minValidationMessage,
      onChange,
      today,
      todayLabel
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const inDisabledValues = disabledValues && disabledValues.some(disabledValue => equals(today, disabledValue));
  const todayButtonDisabled = !isDateInRange(today, min, max) || inDisabledValues;
  return /*#__PURE__*/_jsxs(Outer, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(UITooltip, {
      title: todayButtonDisabled && !inDisabledValues && lazyEval(min && compare(today, min) === -1 ? minValidationMessage : maxValidationMessage),
      children: /*#__PURE__*/_jsx(FooterButton, {
        "data-action": "today",
        disabled: todayButtonDisabled,
        onClick: () => {
          onChange(SyntheticEvent(today));
        },
        children: lazyEval(todayLabel)
      })
    }), /*#__PURE__*/_jsx(FooterButton, {
      "data-action": "clear",
      onClick: () => {
        onChange(SyntheticEvent(null));
      },
      children: lazyEval(clearLabel)
    })]
  }));
}
if (process.env.NODE_ENV !== 'production') {
  CalendarFooterButtons.propTypes = {
    clearable: PropTypes.bool,
    clearLabel: createLazyPropType(PropTypes.string).isRequired,
    disabledValues: PropTypes.arrayOf(SimpleDateType),
    max: SimpleDateType,
    maxValidationMessage: createLazyPropType(PropTypes.string),
    min: SimpleDateType,
    minValidationMessage: createLazyPropType(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    today: SimpleDateType.isRequired,
    todayLabel: createLazyPropType(PropTypes.string).isRequired
  };
}
CalendarFooterButtons.defaultProps = {
  clearable: true,
  clearLabel: () => I18n.text('ui.datePicker.clear'),
  todayLabel: () => I18n.text('ui.datePicker.today')
};
CalendarFooterButtons.displayName = 'CalendarFooterButtons';